import { render, staticRenderFns } from "./ReportsUnitRented.vue?vue&type=template&id=00d51704&"
import script from "./ReportsUnitRented.vue?vue&type=script&lang=ts&"
export * from "./ReportsUnitRented.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00d51704')) {
      api.createRecord('00d51704', component.options)
    } else {
      api.reload('00d51704', component.options)
    }
    module.hot.accept("./ReportsUnitRented.vue?vue&type=template&id=00d51704&", function () {
      api.rerender('00d51704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/reports/ReportsUnitRented.vue"
export default component.exports